// extracted by mini-css-extract-plugin
module.exports = {"trustedWorldwideBigNumbers":"NumbersSlider_trustedWorldwideBigNumbers__z6GOy","trustedWorldwideBigItem":"NumbersSlider_trustedWorldwideBigItem__3kseM"};